<template>
  <div v-if="invalidFeedback" class="invalid-feedback">
    {{ invalidFeedback }}
  </div>
  <div v-else-if="validFeedback" class="valid-feedback">
    {{ validFeedback }}
  </div>
  <div v-else-if="helpText" class="form-text text-muted w-100">
    <small>
      {{ helpText }}
    </small>
  </div>
</template>

<script lang="ts">
export type FieldMessageProps = {
  helpText?: string;
  invalidFeedback?: string;
  validFeedback?: string;
};
</script>

<script lang="ts" setup>
defineProps<FieldMessageProps>();
</script>
